import gql from 'graphql-tag';

// `diet.diets` is the catalogue, identical for everyone, so the viewer's own
// diet access has to come along and gate the tags: someone who already paid
// has nothing to decide and should see none of them.
const query = gql`
  query DietsFreemiumAccess {
    me {
      id
      diet {
        id
        accessTo
      }
    }
    diet {
      diets {
        id
        freemiumAccess {
          isAvailable
          freeDays
        }
      }
    }
  }
`;

export default query;
